import { NgModule } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';

import { TranslateModule } from '@ngx-translate/core';

import { CompanyInfoRoutingModule } from './company-info-routing.module';

import { GetNamePipe } from '../../shared/pipes/get-name.pipe';

import { CompanyInfoComponent } from './company-info.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { NavMenuComponent } from './components/nav-menu/nav-menu.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TripTestimonialsComponent } from './trip-testimonials/trip-testimonials.component';
import { TestimonialsComponent } from '../../shared/components/testimonials/testimonials.component';
import { HeaderBannerComponent } from '../../shared/components/header-banner/header-banner.component';
import { TestimonialCardComponent } from '../../shared/components/testimonial-card/testimonial-card.component';
import { PopularItinerariesComponent } from '../../shared/components/popular-itineraries/popular-itineraries.component';
import { StartPlaningMobileComponent } from '../../shared/components/start-planing-mobile/start-planing-mobile.component';

@NgModule({
  declarations: [
    AboutUsComponent,
    NavMenuComponent,
    CompanyInfoComponent,
    PrivacyPolicyComponent,
    TripTestimonialsComponent,
  ],
  imports: [
    MatIconModule,
    CompanyInfoRoutingModule,
    PopularItinerariesComponent,
    GetNamePipe,
    TranslateModule,
    HeaderBannerComponent,
    TestimonialsComponent,
    TestimonialCardComponent,
    StartPlaningMobileComponent,
  ],
  providers: [GetNamePipe],
})
export class CompanyInfoModule {}
